export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFreactionDigits: 2
});

export const percentageFormatter = (num) => Number(num).toLocaleString(undefined,{style: 'percent', minimumFractionDigits:2});

